<template>
  <div>
    <form action="#" class="pt-4" @submit.prevent="updatePassword">
      <div class="form-floating mb-4">
        <input
          id="currentPassword"
          v-model="currentPassword"
          :class="currentPasswordClass"
          class="form-control"
          :placeholder="$t('changePasswordFormCurrentPassword')"
          type="password"
        />
        <label for="currentPassword">
          {{ $t("changePasswordFormCurrentPassword") }}
        </label>
        <div class="invalid-feedback text-start">
          {{ $t("errorInvalidPassword") }}
        </div>
      </div>

      <div class="form-floating mb-4">
        <input
          id="newPassword"
          v-model="newPassword"
          :class="newPasswordClass"
          class="form-control"
          :placeholder="$t('changePasswordFormNewPassword')"
          type="password"
        />
        <label for="newPassword">
          {{ $t("changePasswordFormNewPassword") }}
        </label>
        <div class="invalid-feedback text-start">
          {{ $t("errorInvalidPassword") }}
        </div>
      </div>

      <div class="form-floating mb-4">
        <input
          id="newPasswordRepeat"
          v-model="newPasswordRepeat"
          :class="newPasswordRepeatClass"
          class="form-control"
          :placeholder="$t('changePasswordFormNewPasswordRepeat')"
          type="password"
        />
        <label for="newPasswordRepeat">
          {{ $t("changePasswordFormNewPasswordRepeat") }}
        </label>
        <div class="invalid-feedback text-start">
          {{ $t("changePasswordFormNewPasswordErrorPasswordsNotMatch") }}
        </div>
      </div>

      <button
        :disabled="buttonDisabled"
        class="btn btn-secondary w-100"
        type="submit"
      >
        <spinner v-if="loading" centered />
        <span v-else>{{ $t("save") }}</span>
      </button>

      <div v-if="error" class="alert alert-danger mt-4">
        {{ errorText }}
      </div>

      <div v-if="success" class="alert alert-success mt-4">
        {{ $t("changePasswordFormSuccess") }}
      </div>
    </form>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
export default {
  name: "ChangePasswordForm",
  components: {
    Spinner,
  },
  data() {
    return {
      currentPassword: null,
      currentPasswordClass: null,
      newPassword: null,
      newPasswordClass: null,
      newPasswordRepeat: null,
      newPasswordRepeatClass: null,
      error: false,
      errorText: null,
      loading: false,
      success: false,
    };
  },
  watch: {
    currentPassword(newValue) {
      this.currentPasswordClass = this.validatePassword(newValue)
        ? "is-valid"
        : "is-invalid";
    },
    newPassword(newValue) {
      if (newValue === this.currentPassword) {
        this.newPasswordClass = "is-invalid";
      } else {
        this.newPasswordClass = this.validatePassword(newValue)
          ? "is-valid"
          : "is-invalid";
      }
    },
    newPasswordRepeat(newValue) {
      this.newPasswordRepeatClass =
        newValue === this.newPassword ? "is-valid" : "is-invalid";
    },
  },
  computed: {
    buttonDisabled() {
      if (
        this.currentPasswordClass === null ||
        this.currentPasswordClass === "is-invalid"
      ) {
        return true;
      }
      if (
        this.newPasswordClass === null ||
        this.newPasswordClass === "is-invalid"
      ) {
        return true;
      }
      if (
        this.newPasswordRepeatClass === null ||
        this.newPasswordRepeatClass === "is-invalid"
      ) {
        return true;
      }
      return this.loading;
    },
  },
  methods: {
    updatePassword() {
      this.loading = false;
      this.error = false;
      this.errorText = null;
      this.success = false;

      const _this = this;

      if (!this.buttonDisabled) {
        this.loading = true;

        this.$store
          .dispatch("user/updateUser", {
            currentPassword: this.currentPassword,
            newPassword: this.newPassword,
          })
          .then(async () => {
            _this.success = true;
            _this.loading = false;
          })
          .catch((error) => {
            _this.error = true;
            _this.errorText = _this.globalErrorText(error);
            _this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped></style>
